import { Partner } from '@witkac/kartamiejska-shared';
import {
  PartnerResource,
  partnerResource
} from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';
/**
 * Moduł partnerów
 *
 * @export
 * @class PartnersModule
 * @extends {EntityModule<Partner, PartnerResource>}
 */
export class PartnersModule extends EntityModule<Partner, PartnerResource> {
  constructor() {
    super(partnerResource);
  }
}

export default new PartnersModule();
